import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Sun, Lock } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

const ADMIN_PASSWORD = "IonSolar2025!";

export default function AdminLogin() {
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = (e) => {
    e.preventDefault();
    setLoading(true);
    
    setTimeout(() => {
      if (password === ADMIN_PASSWORD) {
        sessionStorage.setItem("adminAuth", "true");
        toast.success("Welcome back!");
        navigate("/admin");
      } else {
        toast.error("Incorrect password");
      }
      setLoading(false);
    }, 500);
  };

  return (
    <div className="min-h-screen bg-[#F8FAFC] flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="bg-white rounded-2xl shadow-lg border border-slate-100 p-8">
          <div className="flex items-center justify-center gap-2 mb-6">
            <div className="w-10 h-10 rounded-xl bg-[#1A4D2E] flex items-center justify-center">
              <Sun className="w-6 h-6 text-white" />
            </div>
            <span className="font-['Outfit'] font-bold text-xl text-slate-900">Ion Solar</span>
          </div>
          
          <div className="text-center mb-6">
            <h1 className="text-2xl font-['Outfit'] font-bold text-slate-900">Admin Login</h1>
            <p className="text-sm text-slate-500 mt-1">Enter password to access dashboard</p>
          </div>

          <form onSubmit={handleLogin} className="space-y-4">
            <div>
              <Label htmlFor="password">Password</Label>
              <div className="relative mt-1.5">
                <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
                <Input
                  id="password"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="pl-10 h-12"
                  placeholder="Enter admin password"
                  data-testid="admin-password-input"
                />
              </div>
            </div>

            <Button
              type="submit"
              disabled={!password || loading}
              className="w-full h-12 bg-[#1A4D2E] hover:bg-[#153d25] rounded-full"
              data-testid="admin-login-btn"
            >
              {loading ? "Verifying..." : "Access Dashboard"}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
}
